import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { UsergestorService } from "src/app/services/usergestor.service";
import { NavigationEnd, Router } from "@angular/router";
import { ToastController } from "@ionic/angular";
import { MaskService } from "src/app/services/providers/mask.service";
import { RestaurantService } from "src/app/services/restaurant.service";
import { ConfigurationService } from "src/app/services/configuration.service";
import { Observable, combineLatest, of } from "rxjs";
import { Restaurant } from "src/app/models/restaurant.model";
import { catchError, filter, map, switchMap, take, timeout } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-signin",
  templateUrl: "./signin.page.html",
  styleUrls: ["./signin.page.scss"],
})
export class SigninPage implements OnInit {
  form: FormGroup;

  rest$: Observable<any>;
  appMode$: Observable<any>;

  public topbarMode$: Observable<string>;

  constructor(private formBuilder: FormBuilder, private router: Router, private userGestorController: UsergestorService, private toastController: ToastController, public mask: MaskService, private restService: RestaurantService, private config: ConfigurationService, private location: Location) {
    this.form = this.formBuilder.group({
      email: [""],
      fone: [""],
      senha: ["", Validators.required],
      logintype: ["telefone"],
    });
  }

  ngOnInit() {
    this.rest$ = this.restService.getRest();
    this.appMode$ = this.config.getMode();

    this.topbarMode$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects.replace(`/${environment.routePaths.v2.version}/`, "") || "home")
    );
  }

  goToSignUp() {
    this.router.navigate(["/v2/conta/registro"]);
  }

  goToPassword() {
    this.router.navigate(["/v2/conta/senha"]);
  }

  onSubmit() {
    if (this.form.status === "INVALID") {
      return this.toastController
        .create({
          message: "Formulário inválido",
          duration: 3000,
          color: "danger",
        })
        .then((toast) => {
          toast.present();
        });
    }
    this.userGestorController.authenticateUser(this.form.value).subscribe(
      (result) => {
        if (result.errors === false) {
          let user = result.data;

          this.userGestorController.setUser({
            bairro: user.bairro,
            cep: user.cep,
            complemento: user.complemento,
            email: user.email,
            fone: user.fone,
            localidade: user.localidade,
            logradouro: user.logradouro,
            nome: user.nome,
            numero: user.numero,
            restauranteid: user.restauranteId,
            sobrenome: user.sobrenome,
            uf: user.uf,
            userid: user.userID,
            senha: user.senha,
          });

          this.toastController
            .create({
              duration: 3000,
              message: result.message,
              color: "success",
            })
            .then((toast) => {
              toast.present();
            });

          this.location.back();
        } else {
          this.toastController
            .create({
              message: result.message,
              duration: 3000,
              color: "danger",
            })
            .then((toast) => {
              toast.present();
            });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
